import React from 'react';
import AddSupportingDetailsStep from 'pages/components/AddSupportingDetailsStep';

const ARReferralsAddSupportingDetails = (props) => (
  <AddSupportingDetailsStep {...props} />
);

export default ARReferralsAddSupportingDetails;
